import { useQuery } from '@tanstack/react-query';
import productService from 'v2/services/product';

export function useAffiliatesProductStatusSummary(productId: number) {
  return useQuery({
    queryKey: ['product', productId, 'affiliatesStatusSummary'],
    queryFn: () => productService.getAffiliatesStatusSummary(productId),
    enabled: false
  });
}
